import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  color: #fff;
`;

export const Header = styled.div`
  height: 70px;
  width: 100%;
  background: #201f1f;
`;

export const Nav = styled.div`
  width: 270px;
  background: #262525;
`;

export const Content = styled.div`
  width: 100%;
  background: #292828;
`;
